// OnboardingLandingPage.js
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../App.css";
import side_banner from "../images/international-transfers.png";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Includes/Header";
import Footer from "./Includes/Footer";
import { useDispatch, useSelector } from "react-redux";
import { setAppName, resetAllFields } from "./authslice";
import { AppDispatch, RootState } from "./store";
import { useTranslation } from "react-i18next";
interface OnboardingLandingPageProps { }

interface OnboardingState {
  appName: string | null;
}

const OnboardingLandingPage: React.FC<OnboardingLandingPageProps> = () => {
  const [appName, setAppNameState] = useState<OnboardingState["appName"]>(null);

  const dispatch = useDispatch<AppDispatch>();
  const theme = useSelector((state: RootState) => state.theme.theme);
  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetAllFields());
    const params = new URLSearchParams(window.location.search);
    const appNameParam = params.get("appname");
    setAppNameState(appNameParam);

    if (appNameParam !== null) {
      dispatch(setAppName(appNameParam));
    }
  }, [dispatch]);

  const handleLoginClick = (): void => {
    // if (appName === "ArmupExchange") {
      window.location.href = process.env.REACT_APP_ARMF_APP_URL as string;
      localStorage.setItem("platform", 'armf');
    // }
  };

  return (
    <>
      <Header />
      <div className="landing-layout flex-grow-1">
        {/* Left panel */}
        <div className="landing-left">
          <h2 className="onboarding-title">{t("landing.title")}</h2>

          <div className="landing-cta-group mt-4">
            <Button
              className="btn btn-primary rounded-5 landing-cta-btn landing-cta-primary"
              onClick={() => navigate("/onboarding")}
            >
              <i className="fa-solid fa-user me-2" />
              {t("landing.createPersonal")}
            </Button>

            <div className="landing-divider d-flex align-items-center gap-3 my-3">
              <hr className="flex-grow-1 m-0" />
              <span className="text-muted small fw-semibold">{t("landing.or")}</span>
              <hr className="flex-grow-1 m-0" />
            </div>

            <Button
              className="btn btn-entity rounded-5 landing-cta-btn landing-cta-primary"
              onClick={() => navigate("/onboardingEntityAccount")}
            >
              <i className="fa-solid fa-building me-2" />
              {t("landing.openBusiness")}
            </Button>
          </div>

          <div className="landing-links mt-4">
            <span className="text-secondary small">
              {t("landing.alreadyRegistered")}{" "}
              <Link className="text-primary link-text" to="#" onClick={handleLoginClick}>
                {t("landing.logIn")}
              </Link>
            </span>
          </div>
        </div>

        {/* Right panel */}
        <div className={`landing-right ${theme === "light" ? "bg-sky" : "bg-dark-solid shadow-sm"}`}>
          <img src={side_banner} alt="Side Banner" className="landing-banner-img" />
          <h2 className="trade-confidence mt-4">{t("landing.tagline")}</h2>
          <p className="text-secondary description-text mt-2">
            {t("landing.description")}
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OnboardingLandingPage;
